import { ModKeys } from "@intelligems/ig-types";
import { IGlobalState } from "@src/store/slices/global";

export type ExperienceInfoSetDialog = {
  text: string;
  dialog: keyof IGlobalState["dialogs"];
  open: boolean;
  props?: any;
  clearProps?: boolean;
};

export type AlertState = {
  key: string;
  customMessage?: string;
  docLink?: string;
  setDialog?: ExperienceInfoSetDialog;
};

export type IExperienceInfoStateSlice = {
  alertOpen: boolean;
  warnings: AlertState[];
  errors: AlertState[];
  activatedModArr: ModKeys[];
  showErrors: boolean;
  activatedOfferVariationMods: Record<
    string,
    {
      mods: ModKeys[];
    }
  >;
};

export const initialExperienceInfoStateSlice: IExperienceInfoStateSlice = {
  alertOpen: false,
  warnings: [],
  errors: [],
  activatedModArr: [],
  showErrors: false,
  activatedOfferVariationMods: {},
};

export interface ExperienceStateIssue {
  error: boolean;
  key: string;
  type: "warning" | "error";
  customMessage?: string;
  docLink?: string;
  setDialog?: ExperienceInfoSetDialog;
}
